<template>
  <router-view></router-view>
  <!-- ScrollTop -->
  <scrollTop />
</template>

<script>
import scrollTop from './components/include/scrollTop.vue';
require("@/assets/scss/style.min.css");

export default {
  name: 'App',
  components: {
    scrollTop,
  },
}
</script>